// Start React
require('./bootstrap');

// Standard React requires
const React = require('react');
const ReactDOM = require('react-dom/client');

// React Components
require('./components/Find-a-Seminar/FindASeminar');
require('./components/Find-a-Seminar/SearchSeminars');
require('./components/Find-a-Seminar/GetASeminar');

require('./components/Livestream/GetLivestream');
require('./components/Livestream/LivestreamAttendance');
require('./components/Livestream/LivestreamAttendanceLive');

require('./components/Ministry/Create');
require('./components/Ministry/Renewal');
require('./components/Ministry/Renewals');
require('./components/Ministry/Update');
require('./components/Ministry/Recordings');
require('./components/Ministry/Newsletter');
require('./components/Ministry/Handbook');
require('./components/Ministry/Meetings');
require('./components/Ministry/WrappedMinistrySidebar');
require('./components/Ministry/MinistrySidebar');

require('./components/Initiate/Broadcasts');
require('./components/Initiate/InitiateArticles');
require('./components/Initiate/FAQs');
require('./components/Initiate/InitiateSidebar');
require('./components/Initiate/WrappedInitiateSidebar');

require('./components/Seminar-Leader/Articles');
require('./components/Seminar-Leader/Handbook');
require('./components/Seminar-Leader/FAQs');
require('./components/Seminar-Leader/WrappedSeminarLeaderSidebar');
require('./components/Seminar-Leader/SeminarLeaderSidebar');

require('./components/Students/Login');
require('./components/Students/Downloads');
require('./components/Students/Subscriptions');
require('./components/Students/SubscriptionPortal');
require('./components/Students/SubscriptionCart');
require('./components/Students/ResponsiveHeader');

require('./components/Challenges/Search');

require('./components/Seedcards/Seedcard');
require('./components/Seedcards/SeedcardSend');

require('./components/Generic/CustomDialog');

// Video common components
require('./components/Videos/common/MegaMenu');
require('./components/Videos/common/VideoCard');
require('./components/Videos/common/VideoErrorState');
require('./components/Videos/common/VideoLoadingState');
require('./components/Videos/common/InternalNav');
require('./components/Videos/common/SearchBar');
require('./components/Videos/common/SearchHistory');

// Results components
require('./components/Videos/Results');

// Watch components
require('./components/Videos/Watch');
require('./components/Videos/Videos');

// FAQs components
require('./components/Faqs/Index');
require('./components/Faqs/FaqForm');

// Guest Home components
require('./components/Videos/GuestHome/GuestFeatures');
require('./components/Videos/GuestHome/GuestHero');
require('./components/Videos/GuestHome/GuestVideos');
require('./components/Videos/GuestHome/GuestTestimonials');
require('./components/Videos/GuestHome/GuestDevices');
require('./components/Videos/GuestHome/GuestFAQ');
require('./components/Videos/GuestHome/GuestPricing');
require('./components/Videos/GuestHome/GuestFooter');

// Home component mounting via DOM (from previous videos-components.js)
const Home = require('./components/Videos/Home');
const PlaylistRow = require('./components/Videos/Home/PlaylistRow');
const HeroSection = require('./components/Videos/common/HeroSection');
const GuestHome = require('./components/Videos/GuestHome').default;
// Register React components globally (optional for Blade + dynamic mounts)
window.ReactComponents = window.ReactComponents || {};
window.ReactComponents.Home = Home.default || Home;
window.ReactComponents.PlaylistRow = PlaylistRow.default || PlaylistRow;
window.ReactComponents.HeroSection = HeroSection.default || HeroSection;



document.addEventListener('DOMContentLoaded', () => {
  // Mount Home component
  const homeContainer = document.getElementById('home-component');
  if (homeContainer && window.ReactComponents.Home) {
    const root = ReactDOM.createRoot(homeContainer);
    root.render(React.createElement(window.ReactComponents.Home));

    const placeholder = document.getElementById('placeholder-content');
    if (placeholder) {
      placeholder.style.display = 'none';
    }
  }

  // Mount GuestHome component
  const el = document.getElementById('guest-home-root');
  if (el) {
    const featuredVideos = JSON.parse(el.dataset.videos || '[]');
    const isLoggedIn = el.dataset.isLoggedIn === 'true';

    ReactDOM.createRoot(el).render(
      React.createElement(GuestHome, {
        featuredVideos,
        isLoggedIn,
      })
    );
  }
});